<template>
  <div class="sla-custom-tooltip">
    <div
      v-if="mode === 'total'"
      class="sla-custom-tooltip__total"
    >
      <b>Total:</b> {{ totalValue }}
    </div>
    <template v-else-if="mode === 'cell' && tip">
      <div>Date: <b>{{ tip.periodKey }}</b></div>
      <div>Brand: <b>{{ tip.brandName }}</b></div>
      <div>{{ tip.metric }}: <b>{{ tip.metricValue }}{{ tip.suffix }}</b></div>
      <div>
        Units:<span class="sla-custom-tooltip__pad4" />
        <b>{{ tip.pctInSla }}%</b> in SLA (<b>{{ tip.fullSla }}</b> Units)
      </div>
      <div class="sla-custom-tooltip__indent">
        <b>{{ tip.slaPendingUnits }}</b> in SLA Pending and
        <b>{{ tip.unitsOut }}</b> Out of SLA
        (including <b>{{ tip.jammedExpired }}</b> Jammed and Expired Units)
      </div>
      <div>
        Orders: <b>{{ tip.pctInSlaOrders }}%</b> in SLA (<b>{{ tip.fullSlaOrders }}</b> Orders)
      </div>
      <div class="sla-custom-tooltip__indent">
        <b>{{ tip.slaPendingOrders }}</b> in SLA Pending and
        <b>{{ tip.ordersOut }}</b> Out of SLA
        (including <b>{{ tip.jammedOrders }}</b> Jammed and Expired Orders)
      </div>
      <template v-if="tip.noteCount > 0">
        <div class="sla-custom-tooltip__spacer" />
        <div>Notes: <b>{{ tip.noteCount }}</b></div>
        <div>Latest ({{ tip.noteAuthor }}): {{ tip.notePreview }}</div>
        <div class="sla-custom-tooltip__hint">
          Click cell to view history / add note
        </div>
      </template>
      <div
        v-else
        class="sla-custom-tooltip__hint"
      >
        Click cell to add a note
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SlaCellTooltip',
  data() {
    return {
      mode: 'empty',
      totalValue: '',
      tip: null,
    };
  },
  beforeMount() {
    const params = this.params;
    if (!params) {
      this.mode = 'empty';
      return;
    }

    if (params.node && params.node.rowPinned) {
      const colField = params.column && params.column.getColDef
        ? params.column.getColDef().field
        : null;
      const value = (params.data && colField != null)
        ? params.data[colField]
        : params.value;
      this.mode = 'total';
      this.totalValue =
        value !== undefined && value !== null && value !== ''
          ? Number(value).toLocaleString('en-US')
          : '';
      return;
    }

    let tip = params.value;
    if (!tip || typeof tip !== 'object') {
      const rowData = params.data
        || (params.api
          && params.rowIndex != null
          && params.api.getDisplayedRowAtIndex(params.rowIndex)
          && params.api.getDisplayedRowAtIndex(params.rowIndex).data);
      const colField = params.column && params.column.getColDef
        ? params.column.getColDef().field
        : null;
      if (rowData && colField) {
        tip = rowData[`${colField}_tooltip`] || null;
      }
    }

    if (tip && typeof tip === 'object') {
      this.mode = 'cell';
      this.tip = tip;
    } else {
      this.mode = 'empty';
      this.tip = null;
    }
  },
};
</script>

<style>
.sla-custom-tooltip {
  padding: 8px 12px;
  font-size: 15px;
  font-family: Roobert-Regular, 'Inter', 'Segoe UI', Arial, sans-serif;
  background: rgba(255, 255, 255, 0.98);
  color: #181d1f;
  border: 1px solid #d2d6db;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 1.5px 5px rgba(0, 0, 0, 0.08);
  white-space: pre-line;
  pointer-events: none;
  line-height: 1.6;
  z-index: 10000;
  max-width: 520px;
}

.sla-custom-tooltip b {
  font-family: Roobert-Semi-Bold, Roobert-Regular, 'Inter', 'Segoe UI', Arial, sans-serif;
  font-weight: 600;
}

.sla-custom-tooltip__total {
  padding: 5px;
  font-size: 12px;
}

.sla-custom-tooltip__pad4 {
  display: inline-block;
  width: 1.6em;
}

.sla-custom-tooltip__indent {
  padding-left: 4.5em;
}

.sla-custom-tooltip__spacer {
  height: 0.5em;
}

.sla-custom-tooltip__hint {
  font-style: italic;
  opacity: 0.85;
}
</style>
